import React, { createContext, useImperativeHandle, useRef, useState } from 'react'
import BaseModal from '@/component/modal/BaseModal.tsx'
import useQueryGetAlertBioLive from '@/api/notification/getAlertBioLive.ts'
import BioAlertDetail from '@/pages/notification/bio/BioAlertDetail.tsx'
import { isEmptyArray, isNotEmptyArray } from '@/util/array.ts'
import { useTranslation } from 'react-i18next'

export interface IProps {
    className?: string
    refetchAlerts?: () => void
    defaultId?: number
}

export type IAlertBioContextProps = {
    id?: number
    setId: (id: number) => void
    refetchList: () => void
    refetchAndResetSelection: () => void
}

export const BioAlertModalContext = createContext<IAlertBioContextProps>({
    id: undefined,
    setId: () => {
    },
    refetchList: () => {
    },
    refetchAndResetSelection: () => {
    }
})


const BioAlertModal = ({ defaultId, refetchAlerts }: IProps, ref: any) => {
    useTranslation()

    const modalRef = useRef<any>()
    const [id, setId] = useState<number>()
    const { data: bioAlerts, refetch: refetchList } = useQueryGetAlertBioLive(true)

    const refetchAndResetSelection = async () => {
        const { data: resAlerts } = await refetchList()
        setId(undefined)

        const newAlerts = resAlerts?.bios
        if (isEmptyArray(newAlerts)) {
            modalRef.current.close()
            return
        }

        const myAlerts = newAlerts?.filter(item => item?.alert?.isMyTask == true)
        if (myAlerts && isNotEmptyArray(myAlerts)) {
            setId(myAlerts[0].id)
            return
        }

        const notMyAlerts = newAlerts?.filter(item => !item?.alert?.taskManagerAt)
        if (notMyAlerts && isNotEmptyArray(notMyAlerts)) {
            setId(notMyAlerts[0].id)
            return
        }
    }
    useImperativeHandle(ref, () => ({
        show: () => {
            modalRef.current.show()
        },
        close: () => {
            modalRef.current.close()
        }
    }))


    return (
        <BioAlertModalContext.Provider value={{ id, setId, refetchList, refetchAndResetSelection }}>
            <BaseModal
                ref={modalRef}
                width={'1200'}
                onOpenCallback={() => {
                    if (id) return
                    if (defaultId) {
                        setId(defaultId)
                    } else if ((bioAlerts?.bios?.length || 0) > 0) {
                        setId(bioAlerts?.bios[0]!.id)
                    }
                }}
                onCloseCallback={() => {
                    setId(undefined)
                    refetchAlerts && refetchAlerts()
                }}
                showCloseButton={false}>

                <div className={'p-3 sm:p-4 md:p-5 max-h-[90vh] overflow-auto'}>
                    <BioAlertDetail />
                </div>
            </BaseModal>
        </BioAlertModalContext.Provider>

    )
}

export default React.forwardRef(BioAlertModal)
